import styles from "./Player-detail.module.css"
import { Player } from "../lib/player"
interface Props {
  player: Player | null
}

export function PlayerDetail({ player }: Props) {
  return (
    <div className={styles.root}>
      <div>
        <span className={styles.content}>
          <span className={styles.title}>Player ID</span>
          <span className={styles.item}>{player?.displayName}</span>
          <br />
        </span>
        <span className={styles.content}>
          <span className={styles.title}>Device ID</span>
          <span className={styles.item}>{player?.deviceID}</span>
          <br />
        </span>
        <span className={styles.content}>
          <span className={styles.title}>Model</span>
          <span className={styles.item}>{player?.modelName}</span>
          <br />
        </span>
        {player?.serialNumber && (
          <span className={styles.content}>
            <span className={styles.title}>Serial Number</span>
            <span className={styles.item}>{player?.serialNumber}</span>
            <br />
          </span>
        )}
        {player?.externalID && (
          <span className={styles.content}>
            <span className={styles.title}>External ID</span>
            <span className={styles.item}>{player?.externalID}</span>
            <br />
          </span>
        )}
        <span className={styles.content}>
          <span className={styles.title}>Timezone</span>
          <span className={styles.item}>{player?.timeZone}</span>
          <br />
        </span>

        <span className={styles.content}>
          <span className={styles.title}>Last Connection</span>
          <span className={styles.item}>{player?.lastConnection ? player?.lastConnection : "Never connected"}</span>
          <br />
        </span>

        <span className={styles.content}>
          <span className={styles.title}>Firmware</span>
          <span className={styles.item}>{player?.firmwareVersion}</span>
          <br />
        </span>
        <span className={styles.content}>
          <span className={styles.title}>Mac Address</span>
          <span className={styles.item}>{player?.macAddress}</span>
          <br />
        </span>
        {player?.wifiMacAddress && (
          <span className={styles.content}>
            <span className={styles.title}>Wifi Mac Address</span>
            <span className={styles.item}>{player?.wifiMacAddress}</span>
            <br />
          </span>
        )}
        <span className={styles.content}>
          <span className={styles.title}>Local IP</span>
          <span className={styles.item}>{player?.ipAddress ? player?.ipAddress : player?.isDHCP ? "DHCP" : ""}</span>
          <br />
        </span>
        {player?.publicIp && (
          <span className={styles.content}>
            <span className={styles.title}>Public IP </span>
            <span className={styles.item}>{player?.publicIp}</span>
            <br />
          </span>
        )}
      </div>
    </div>
  )
}
